// Traduções do Corrigir datas da prancha — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'transporte.editarDatas.acao': 'Corrigir Início e Fim',
    'transporte.editarDatas.titulo': 'Corrigir datas da prancha',
    'transporte.editarDatas.aviso': 'O Início e o Fim nascem da troca de status. Corrija aqui quando a data real foi outra.',
    'transporte.editarDatas.inicio': 'Início',
    'transporte.editarDatas.fim': 'Fim',
    'transporte.editarDatas.noProtheus': 'No Protheus',
    'transporte.editarDatas.usarProtheus': 'Usar as datas do Protheus',
    'transporte.editarDatas.semInicio': 'O Início nasce quando a prancha sai.',
    'transporte.editarDatas.semFim': 'O Fim nasce quando a viagem é Finalizada.',
    'transporte.editarDatas.erroFalta': 'Preencha as datas.',
    'transporte.editarDatas.erroFutura': 'A data não pode ser futura.',
    'transporte.editarDatas.erroOrdem': 'O Fim não pode ser antes do Início.',
    'transporte.editarDatas.salvo': 'Datas da prancha corrigidas.',
  },
  en: {
    'transporte.editarDatas.acao': 'Correct start and end',
    'transporte.editarDatas.titulo': 'Correct flatbed dates',
    'transporte.editarDatas.aviso': 'Start and end come from the status change. Correct them here when the real date was different.',
    'transporte.editarDatas.inicio': 'Start',
    'transporte.editarDatas.fim': 'End',
    'transporte.editarDatas.noProtheus': 'In Protheus',
    'transporte.editarDatas.usarProtheus': 'Use the Protheus dates',
    'transporte.editarDatas.semInicio': 'The start is set when the flatbed leaves.',
    'transporte.editarDatas.semFim': 'The end is set when the trip is Finished.',
    'transporte.editarDatas.erroFalta': 'Fill in the dates.',
    'transporte.editarDatas.erroFutura': 'The date cannot be in the future.',
    'transporte.editarDatas.erroOrdem': 'The end cannot be before the start.',
    'transporte.editarDatas.salvo': 'Flatbed dates corrected.',
  },
  es: {
    'transporte.editarDatas.acao': 'Corregir inicio y fin',
    'transporte.editarDatas.titulo': 'Corregir fechas de la plataforma',
    'transporte.editarDatas.aviso': 'El inicio y el fin nacen del cambio de estado. Corríjalos aquí cuando la fecha real fue otra.',
    'transporte.editarDatas.inicio': 'Inicio',
    'transporte.editarDatas.fim': 'Fin',
    'transporte.editarDatas.noProtheus': 'En Protheus',
    'transporte.editarDatas.usarProtheus': 'Usar las fechas de Protheus',
    'transporte.editarDatas.semInicio': 'El inicio nace cuando la plataforma sale.',
    'transporte.editarDatas.semFim': 'El fin nace cuando el viaje se Finaliza.',
    'transporte.editarDatas.erroFalta': 'Complete las fechas.',
    'transporte.editarDatas.erroFutura': 'La fecha no puede ser futura.',
    'transporte.editarDatas.erroOrdem': 'El fin no puede ser antes del inicio.',
    'transporte.editarDatas.salvo': 'Fechas de la plataforma corregidas.',
  },
}
